import { render, staticRenderFns } from "./SlotPhoto.vue?vue&type=template&id=b909cdf8&scoped=true&"
import script from "./SlotPhoto.vue?vue&type=script&lang=js&"
export * from "./SlotPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b909cdf8",
  null
  
)

export default component.exports